
import DemandList from '../components/demand-list.vue';

export default {
  name: 'AssignedDemandList',

  components: {
    DemandList: DemandList
  }
};